<template>
  <div class="text-textColor">
    <transition name="fade">
      <div
          v-if="showCreate360Question"
          class="bg-black fixed bg-opacity-70 inset-0 z-50 h-screen w-full"
      >
        <form
            @submit.prevent="create"
            class="fixed center-h-v bg-white rounded-md shadow-2xl sm:w-2/5 w-full md:h-auto h-screen overflow-auto"
        >
          <transition name="fade">
            <div
                v-if="loading"
                class="inset-0 absolute bg-black rounded-md bg-opacity-10 w-full"
            >
              <loader class="center-h-v" />
            </div>
          </transition>

          <div
              class="flex justify-between items-center bg-white sticky top-0 border-b-1.5 p-3"
          >
            <p class="text-base">Add 360 Evaluation Question</p>
            <img
                class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
                src="@/assets/icons/cross-white.png"
                @click="close()"
            />
          </div>
          <div class="grid grid-cols-1 p-4 gap-5">
            <div class="text-sm">
              <label class="block pb-1">Question</label>
              <textarea
                  v-model="info.Question"
                  required
                  rows="5"
                  class="p-2 bg-gray-200 rounded-md w-full"
              />
            </div>
          </div>

          <div class="flex justify-end p-5">
            <button
                class="bg-primary rounded-full px-10 text-sm text-white py-2"
            >
              Create
            </button>
          </div>
        </form>
      </div>
    </transition>
  </div>
</template>

<script>
import Loader from "@/components/loader/loader.vue";
import axios from "axios";

import { mapGetters } from "vuex";
export default {
  name: "CreateReviewPeriodId",
  props: ["showCreate360Question", "reload"],
  components: { Loader },
  data() {
    return {
      info: {
        Question: null,
      },
      loading: false,
      isFocused: false,
    };
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken"]),
  },

  methods: {
    close() {
      this.$emit("close");
      this.info = {
        ReviewPeriodId: null,
        Name: null,
        Description: null,
        Weight: "",
      };
    },
    create() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };
      try {
        axios
            .post(
                `${this.getOrganization}/performance/360evaluation/question/${this.$ApiVersion}/create`,
                JSON.stringify(this.info),
                options
            )
            .then((response) => {
              this.loading = false;
              if (response.data.StatusCode == 200) {
                this.$emit("close");
                this.$notify.success({
                  title: "Success",
                  message: response.data.StatusMessage,
                });
                this.info = {
                  ReviewPeriodId: null,
                  Name: null,
                  Description: null,
                  Weight: "",
                };
                this.reload();
              } else {
                this.loading = false;
                this.$notify.error({
                  title: "Failure",
                  message: response.data.StatusMessage,
                });
              }
            })
            .catch((error) => {
              this.loading = false;
              this.$notify.error({
                title: "Failure",
                message: error?.message,
              });
            });
      } catch (error) {
        this.loading = false;
        this.$notify.error({
          title: "Failure",
          message: error?.message,
        });
      }
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
